import { useQuery } from "react-query";

import { makeRequest } from "../../util";
import { WebTrackerMonitoringSite } from "../types";

export default function useListWebTrackerMonitoringSites() {
  return useQuery({
    queryKey: "list-web-tracker-monitoring-sites",
    queryFn: async () => {
      const res = await makeRequest<WebTrackerMonitoringSite[]>(
        "list_web_tracker_monitoring_sites",
        undefined,
        {
          validateStatus: (status) => status === 200,
        }
      );

      return res.data;
    },
  });
}
